import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Header } from "../components/header/Header";
import logoSmall from "../assets/images/logo-dead.png";
import { BorderedContainer } from "../components/BorderedContainer";
import BackgroundColor from "../components/BackgroundColor";

export const ErrorPage = () => {
  const { t } = useTranslation();
  return (
    <BackgroundColor>
      <Header />
      <div className="flex justify-center items-center text-slate-200">
        <BorderedContainer className="w-full lg:w-1/2 my-32">
          <div className="flex flex-col space-y-2 justify-center items-center pb-10 pt-4">
            <h1 className="text-blue-500 text-2xl">404</h1>
            <h1 className=" text-xl">{t("error.somethingWentWrong")}</h1>
            <img className="h-32" src={logoSmall} alt="liifer" />
            <div className="flex space-x-1">
              <Link
                className="hover:text-blue-500 underline"
                to="/"
                draggable={false}
              >
                {t("form.clickHere")}
              </Link>
              <span>{t("error.toReturn")}</span>
            </div>
          </div>
        </BorderedContainer>
      </div>
    </BackgroundColor>
  );
};

export default ErrorPage;
